import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    description: 'Label for the title representing the customer information section',
    defaultMessage: 'Label History {count, plural, =0 {} one {(#)} other {(#)} }',
    id: 'nvUItH',
  },
  expandableSectionAriaLabel: {
    description: 'Aria label for the expandable customer information section',
    defaultMessage: 'Customer Information expander section',
    id: 'kqw+1p',
  },
  shipmentLinkText: {
    description: 'Text for the link to the shipment',
    defaultMessage: '<a>Shipment {counter}</a> is <b></b>',
    id: 'rBv3RX',
  },
  shippingCostLabel: {
    description: 'Label for the shipping cost',
    defaultMessage: 'Total Cost: <cost></cost>',
    id: 'gYqppd',
  },
  zeroStateHeader: {
    description: 'Header for the Label History zero state section in Planning',
    defaultMessage: 'No Labels Yet',
    id: 'Add9Hw',
  },
  zeroStateLabel: {
    description: 'Label for the Label History zero state section in Planning',
    defaultMessage: 'To create a label, move Item out of Planning',
    id: 's+iJwX',
  },
  noLabelProviderOnShipmentMessage: {
    description: 'Message to display in the Label History part of Planning when a shipment does not have a label provider',
    defaultMessage: 'No carrier service selected',
    id: 'HNe1bS',
  },
});
